import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {Button, Col, Form, Input, Row, Spin} from "antd";
import {useHistory} from "react-router-dom";
import {BusinessSectorCreateEditDto, CompanyListItemDto} from "../generated-api";
import {BackButton} from "../components/layout/BackButton";
import {getBusinessSectorGuid, updateBusinessSectorGuid, useBusinessSectorGuid} from "../hooks/businessSectors";

export function BusinessSectorPage({match}: any) {
    const {businessSectorId} = (match || {}).params || {};
    const {t} = useTranslation();
    const history = useHistory();
    const businessSectorResponse = useBusinessSectorGuid();
    useEffect(() => {
        if (businessSectorId) {
            getBusinessSectorGuid(businessSectorId, true).then().catch(error => {
                console.error(error);
                history.push('/businessSectors');
            });
        } else {
            history.push('/businessSectors');
        }
    }, [businessSectorId]);
    const businessSector = (businessSectorResponse || {}).data;
    const companies = (businessSector || {}).companies || [];

    const onFinish = (values: BusinessSectorCreateEditDto): void => {
        updateBusinessSectorGuid(businessSectorId, values).then(() => {
            history.push('/businessSectors');
        }).catch(console.error);
    };

    const validateMessages = {
        required: t('error.required'),
        string: {
            max: t('error.string.max')
        }
    };

    return (
        <Spin spinning={businessSectorResponse.loading}>
            <PageHeader/>
            <div className={'top-block accent6-background'}>
                <div className={'flex-row'}>
                    <h1 className={'h1 flex-auto'}><BackButton
                        backPath={'/businessSectors'}/>{t('businessSector.title')}</h1>
                </div>
            </div>
            <div className={'subpage-content'}>
                <Form name="businessSector" key={businessSectorResponse.loading}
                      onFinish={onFinish}
                      autoComplete={'off'}
                      labelCol={{span: 11}}
                      validateMessages={validateMessages}
                      initialValues={businessSectorResponse.data}
                      validateTrigger={'onSubmit'}>
                    <Row className={'row-offset'}>
                        <Col span={24} md={18} lg={12} xl={8}>
                            <Form.Item label={t('businessSector.name')} className={'label-left'}
                                       name={'name'} rules={[{required: true}, {max: 512}]}>
                                <Input/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row className={'row-offset mb-15'}>
                        <Col span={24}>
                            <div className={'ant-form-item-label'}>
                                <h2>{t('businessSector.companies')}</h2>
                            </div>
                            <div>
                                {companies.map((item: CompanyListItemDto, index: number) =>
                                    <span className={'nowrap mr-05'}>
                                        {item.name} ({item.registryCode}){index < (companies.length - 1) ? ', ' : ''}
                                    </span>
                                )}
                            </div>
                            {!companies.length && <div className={'no-data'}>{t('general.noData')}</div>}
                        </Col>
                    </Row>
                    <Form.Item className={'no-margin text-right'}>
                        <Button type="primary" className={'accent6-background text-white w-100'} htmlType="submit">
                            {t('businessSector.save')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Spin>
    )
}
